// Generated by Avo VERSION 168.54.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Staging = "staging",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "nEoyD5TzJ8IPCnth9ovx";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "fjCO7ua3GzyApRijrf7Q",
          "br": "uM2Y3M8zQJV5zqtT9_7el",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "JmwsgKTQe50MTmUE9FVs",
          "se": (new Date()).toISOString(),
          "so": "ghBUMPbYP",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "fjCO7ua3GzyApRijrf7Q",
          "br": "uM2Y3M8zQJV5zqtT9_7el",
          "en": env,
          "ty": type,
          "sc": "JmwsgKTQe50MTmUE9FVs",
          "se": (new Date()).toISOString(),
          "so": "ghBUMPbYP",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "JmwsgKTQe50MTmUE9FVs",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export const Language = {
  'EN': 'en',
  'ES': 'es',
  'FR': 'fr',
  'DE': 'de',
  'IT': 'it',
  'SV': 'sv',
  'PL': 'pl',
  'ZH': 'zh',
  'KO': 'ko',
} as const;
export type LanguageType = typeof Language;
export type LanguageValueType = LanguageType[keyof LanguageType];

export const LoggedIn = {
  'TRUE': 'true',
  'FALSE': 'false',
} as const;
export type LoggedInType = typeof LoggedIn;
export type LoggedInValueType = LoggedInType[keyof LoggedInType];

export const EventCategory = {
  'CHECKOUT_INTERACTIONS': 'checkout_interactions',
  'PLP_INTERACTIONS': 'plp_interactions',
  'PDP_INTERACTIONS': 'pdp_interactions',
  'GLOBAL_INTERACTIONS': 'global_interactions',
  'FOOTER_INTERACTIONS': 'footer_interactions',
  'JOURNAL_INTERACTIONS': 'journal_interactions',
  'CM_INTERACTIONS': 'cm_interactions',
  'LOOKBUILDER_INTERACTIONS': 'lookbuilder_interactions',
  'INSTORE_INTERACTIONS': 'instore_interactions',
  'ECOMMERCE_INTERACTIONS': 'ecommerce_interactions',
  'BTC_INTERACTIONS': 'btc_interactions',
  'BOOKING_INTERACTIONS': 'booking_interactions',
  'LOGIN_INTERACTIONS': 'login_interactions',
  'SP_INTERACTIONS': 'sp_interactions',
  'CONFIGURATOR_INTERACTIONS': 'configurator_interactions',
} as const;
export type EventCategoryType = typeof EventCategory;
export type EventCategoryValueType = EventCategoryType[keyof EventCategoryType];

export const Country = {
  'US': 'us',
  'CA': 'ca',
  'NL': 'nl',
  'GB': 'gb',
  'DE': 'de',
  'FR': 'fr',
  'BE': 'be',
  'IT': 'it',
  'SE': 'se',
  'CH': 'ch',
  'PL': 'pl',
  'ES': 'es',
  'FI': 'fi',
  'DK': 'dk',
  'AT': 'at',
  'NO': 'no',
  'CZ': 'cz',
  'HR': 'hr',
  'HU': 'hu',
  'EE': 'ee',
  'LV': 'lv',
  'LT': 'lt',
  'GR': 'gr',
  'IE': 'ie',
  'SG': 'sg',
  'IN': 'in',
  'AU': 'au',
  'CN': 'cn',
  'BN': 'bn',
  'JP': 'jp',
  'HK': 'hk',
  'MO': 'mo',
  'MV': 'mv',
  'MY': 'my',
  'IR': 'ir',
  'LY': 'ly',
  'PT': 'pt',
  'RO': 'ro',
  'CY': 'cy',
  'SK': 'sk',
  'BG': 'bg',
  'SI': 'si',
  'AE': 'ae',
  'GH': 'gh',
  'GI': 'gi',
  'GW': 'gw',
  'IS': 'is',
  'JE': 'je',
  'LI': 'li',
  'MC': 'mc',
  'MT': 'mt',
  'QA': 'qa',
  'DO': 'do',
  'GP': 'gp',
  'MQ': 'mq',
  'PR': 'pr',
  'TT': 'tt',
  'KR': 'kr',
  'LU': 'lu',
} as const;
export type CountryType = typeof Country;
export type CountryValueType = CountryType[keyof CountryType];

export const Affiliation = {
  'WEBSTORE_EUR': 'webstore-eur',
  'WEBSTORE_USD': 'webstore-usd',
  'WEBSTORE_CAD': 'webstore-cad',
  'WEBSTORE_PLN': 'webstore-pln',
  'WEBSTORE_AUD': 'webstore-aud',
  'WEBSTORE_SEK': 'webstore-sek',
  'WEBSTORE_CHF': 'webstore-chf',
  'WEBSTORE_DKK': 'webstore-dkk',
  'WEBSTORE_AED': 'webstore-aed',
  'WEBSTORE_NOK': 'webstore-nok',
  'WEBSTORE_CNY': 'webstore-cny',
  'WEBSTORE_SGD': 'webstore-sgd',
  'WEBSTORE_HKD': 'webstore-hkd',
  'WEBSTORE_GBP': 'webstore-gbp',
  'WEBSTORE_KRW': 'webstore-krw',
} as const;
export type AffiliationType = typeof Affiliation;
export type AffiliationValueType = AffiliationType[keyof AffiliationType];

export const Brand = {
  'SUITSUPPLY': 'suitsupply',
} as const;
export type BrandType = typeof Brand;
export type BrandValueType = BrandType[keyof BrandType];

export const PageType = {
  'HOME': 'home',
  'PRODUCT': 'product',
  'CATEGORY': 'category',
  'JOURNAL': 'journal',
  'STORE': 'store',
  'LOOKBUILDER': 'lookbuilder',
  'LOGIN': 'login',
  'WISHLIST': 'wishlist',
  'ACCOUNT': 'account',
  'CHECKOUT': 'checkout',
  'CART': 'cart',
  'SUPPORT': 'support',
  'CUSTOMMADE': 'custommade',
  'GIFTCARD': 'giftcard',
  'ERROR': 'error',
  'INSTORE': 'instore',
  'CATEGORY_LANDING': 'category_landing',
  'BLACK_TIE_CONFIGURATOR': 'black-tie-configurator',
  'MINI_CART': 'mini-cart',
} as const;
export type PageTypeType = typeof PageType;
export type PageTypeValueType = PageTypeType[keyof PageTypeType];

export const Currency = {
  'EUR': 'eur',
  'USD': 'usd',
  'CNY': 'cny',
  'AUD': 'aud',
  'BGN': 'bgn',
  'CAD': 'cad',
  'CZK': 'czk',
  'DKK': 'dkk',
  'HKD': 'hkd',
  'HUF': 'huf',
  'ISK': 'isk',
  'INR': 'inr',
  'JPY': 'jpy',
  'CHF': 'chf',
  'MOP': 'mop',
  'MYR': 'myr',
  'NOK': 'nok',
  'QAR': 'qar',
  'RON': 'ron',
  'SGD': 'sgd',
  'SEK': 'sek',
  'AED': 'aed',
  'GBP': 'gbp',
  'PLN': 'pln',
  'KRW': 'krw',
} as const;
export type CurrencyType = typeof Currency;
export type CurrencyValueType = CurrencyType[keyof CurrencyType];

export const EventLocation = {
  'LOOKBUILDER_SUMMARY': 'lookbuilder_summary',
  'MINICART_PANEL': 'minicart_panel',
  'MIXANDMATCH': 'mixandmatch',
  'OUT_OF_STOCK_PANEL': 'out_of_stock_panel',
  'PDP': 'pdp',
  'PRODUCTS_MWTW_PANEL': 'products_mwtw_panel',
  'PWSF_PANEL': 'pwsf_panel',
  'SIMILAR_PRODUCTS_PANEL': 'similar_products_panel',
  'SIZE_PASSAPORT_PANEL': 'size-passaport_panel',
  'WISHILIST_PANEL': 'wishilist_panel',
  'CM_JACKET_FABRIC': 'cm_jacket_fabric',
  'CM_JACKET_JACKET': 'cm_jacket_jacket',
  'CM_JACKET_SUMMARY': 'cm_jacket_summary',
  'CM_SHIRT_FABRIC': 'cm_shirt_fabric',
  'CM_SHIRT_SHIRT': 'cm_shirt_shirt',
  'CM_SHIRT_SUMMARY': 'cm_shirt_summary',
  'CM_SUIT_FABRIC': 'cm_suit_fabric',
  'CM_SUIT_JACKET': 'cm_suit_jacket',
  'CM_SUIT_SUMMARY': 'cm_suit_summary',
  'CM_SUIT_TROUSERS': 'cm_suit_trousers',
  'CM_SUIT_WAISTCOAT': 'cm_suit_waistcoat',
  'CM_TROUSER_FABRIC': 'cm_trouser_fabric',
  'CM_TROUSER_SUMMARY': 'cm_trouser_summary',
  'CM_TROUSER_TROUSERS': 'cm_trouser_trousers',
  'CM_TUXEDO_FABRIC': 'cm_tuxedo_fabric',
  'CM_TUXEDO_SUMMARY': 'cm_tuxedo_summary',
  'CM_TUXEDO_TUXEDOJACKET': 'cm_tuxedo_tuxedoJacket',
  'CM_TUXEDO_TUXEDOTROUSER': 'cm_tuxedo_tuxedoTrouser',
  'CM_TUXEDO_TUXEDOWAISTCOAT': 'cm_tuxedo_tuxedoWaistcoat',
  'CM_TUXEDOJACKET_FABRIC': 'cm_tuxedojacket_fabric',
  'CM_TUXEDOJACKET_SUMMARY': 'cm_tuxedojacket_summary',
  'CM_TUXEDOJACKET_TUXEDOJACKET': 'cm_tuxedojacket_tuxedoJacket',
  'CM_TUXEDOSHIRT_FABRIC': 'cm_tuxedoshirt_fabric',
  'CM_TUXEDOSHIRT_SUMMARY': 'cm_tuxedoshirt_summary',
  'CM_TUXEDOSHIRT_TUXEDOSHIRT': 'cm_tuxedoshirt_tuxedoShirt',
  'CM_TUXEDOTROUSER_FABRIC': 'cm_tuxedotrouser_fabric',
  'CM_TUXEDOTROUSER_SUMMARY': 'cm_tuxedotrouser_summary',
  'CM_TUXEDOTROUSER_TUXEDOTROUSER': 'cm_tuxedotrouser_tuxedoTrouser',
  'CM_WAISTCOAT_FABRIC': 'cm_waistcoat_fabric',
  'CM_WAISTCOAT_SUMMARY': 'cm_waistcoat_summary',
  'CM_WAISTCOAT_WAISTCOAT': 'cm_waistcoat_waistcoat',
  'HEADER': 'header',
  'MENU': 'menu',
  'CUFFLINKS_SUMMARY': 'cufflinks_summary',
  'SHIRT_SUMMARY': 'shirt_summary',
  'SHOES_SUMMARY': 'shoes_summary',
  'SUSPENDERS_SUMMARY': 'suspenders_summary',
  'TROUSER_SUMMARY': 'trouser_summary',
  'BOOKING_TOOL_PANEL': 'booking_tool_panel',
} as const;
export type EventLocationType = typeof EventLocation;
export type EventLocationValueType = EventLocationType[keyof EventLocationType];

let Segment: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    destinationOptions: any,
    SegmentDestination: CustomDestination) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn("[avo] ****************************************************");
    InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
    InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
    InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
    InternalAvoLogger.warn("[avo] ****************************************************");
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log("[avo] ****************************************************");
    InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
    InternalAvoLogger.log("[avo] - No events will be sent");
    InternalAvoLogger.log("[avo] - No network requests are made");
    InternalAvoLogger.log("[avo] ****************************************************");
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
  }
  
  destinationOptions = destinationOptions || {};
  
  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
    
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }
    if (__AVO_ENV__ === AvoEnv.Staging) {
    }
    
    Segment = SegmentDestination;
    if (__AVO_ENV__ === 'prod') {
      Segment && Segment.make && Segment.make(__AVO_ENV__, "4OhwIsrqFzQ0aeuYev8muGSWiimGtGIG");
    } else if (__AVO_ENV__ === 'dev') {
      Segment && Segment.make && Segment.make(__AVO_ENV__, null);
    } else {
      Segment && Segment.make && Segment.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

function assertPrice(price: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertFloat("5RMsvPEmT", _label ? "price" + ': ' + _label : "price", price));
  messages = messages.concat(AvoAssert.assertMin("5RMsvPEmT", _label ? "price" + ": " + _label : "price", 0.000000, price));
  return messages;
}

function assertValue(value: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertFloat("Kddfsr3Xx", _label ? "value" + ': ' + _label : "value", value));
  messages = messages.concat(AvoAssert.assertMin("Kddfsr3Xx", _label ? "value" + ": " + _label : "value", 0.000000, value));
  return messages;
}

function assertQuantity(quantity: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertInt("fg1kaNXr_", _label ? "quantity" + ': ' + _label : "quantity", quantity));
  messages = messages.concat(AvoAssert.assertMin("fg1kaNXr_", _label ? "quantity" + ": " + _label : "quantity", 1, quantity));
  return messages;
}

function assertPosition(position: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertInt("pBPbnpdFj", _label ? "position" + ': ' + _label : "position", position));
  messages = messages.concat(AvoAssert.assertMin("pBPbnpdFj", _label ? "position" + ": " + _label : "position", 1, position));
  return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface ProductViewedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  listId: string | null | undefined;
  itemListName: string | null | undefined;
  productId: string;
  category: string;
  affiliation: AffiliationValueType;
  name: string;
  variant: string | null | undefined;
  price: number;
  quantity: number;
  position: number;
  onlineMaterial: string | null | undefined;
  fitId: string | null | undefined;
  sku: string;
  fullLook: string | null | undefined;
  value: number;
}
/**
 * Product Viewed: When landing an a PDP, or clicking on 'select size' in panel

 * 
 * When to trigger this event:
 * 1. When clicking on 'Select Size' in the 'Shop the Look' panel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4a040kO3L/trigger/biZR2zvCbF
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.listId: This describes the listname + unique location

for custommade it's: custom-made, should match regex: ^(|black-tie-package_(configurator|journal)|category_page|category_page_filtered|category-page-landing_(classic-suits|jackets-tuxedo|perennial-suits|shirts-tuxedo|suits-tuxedo|traveller-suits|tuxedo-suits|wedding-suits)|color-swatch_pdp|colour-swatch_pdp|custom-made|discover-our-collection_journal_(alter-your-fit|custom-made|the-hallmarks-of-a-quality-(shirt|shoe))|discover-the-new-collection_(csr-landing|newsletter-emailpreferences)|e\.thomas-collection_journal_e-thomas-mill|explore-the-collection_journal_(4-ply-traveller-collection|angelico-mill|candiani-mill|delfino-mill|drago-mill|fossati-mill|how-to-take-care-of-your-(knits|suits)|perennial-suits|reda-mill|reggiani-mill|relaxed-trousers-guide|weba-mill)|giftcard_landing|gift-wrapping_(cart|mini-cart)|most-popular_(store-detail|store-locator)|search|shop-(french-linen|indonesian-mother-of-pearl|the-look)_(journal_expedition-jort-the-tailoring-trail|custommade|lookbuilder_summary-screen|minicart|slider(_[1-7])?|wishlist)|view-similar-items_oos|wishlist|you-might-also-like_pdp)$
 * @param properties.itemListName: Name of list where products are shown

For custommade, it's 'custom made', should match regex: ^(|black tie package|category page|category page filtered|category page landing|color swatch|colour swatch|custom made|discover the new collection|explore the collection|gift wrapping|giftcard landing|most popular|search|shop the look|view similar items|wishlist|you might also like)$
 * @param properties.productId: SKU of product

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.category: Product Category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
Will be gift card for giftcard

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.variant: Should return size for all products except giftcard. For Giftcard should return 'physical' or 'electronic', should match regex: ^(|5|6|6\.5|7|7\.5|8|8\.5|9|9\.5|10|10\.5|11|12|13|14|14\s1\/2|15|15\s1\/2|15\s3\/4|16|16\s1\/2|17|17\s1\/2|18|18\s1\/2|19|22|23|24|25|26|27|28|29|30|32|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|50|52|54|56|58|60|62|75|85|90|94|95|98|102|105|106|110|114|118|14\s1\/2s|15\s1\/2l|16l|17\s1\/2l|17\s3\/4l|17l|18\s1\/2s|29\/32|30\/32|30l|30s|31\/32|31\/34|32\/32|32\/34|32l|32s|33\/32|33\/34|34\/32|34\/34|34l|34s|35\/34|35\/36|36\/34|36l|36s|37\/38|37l|37s|38-7|38l|38s|39\/40|39-42|39-7|39l|39l\/40l|40-7|40l|40s|41\/42|41l|41l\/42l|42l|42s|43\/44|43-46|43l|43l\/44l|44l|44s|45\/46|46l|46s|47l|47s|48l|48s|52l|52s|56s|CustomMade|electronic|l|m|one-size|physical|s|xl|xs|xxl)$
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added to cart
 * @param properties.position: Position of product, should always start with 1 
 * @param properties.onlineMaterial: Material of product
 * @param properties.fitId: no description
 * @param properties.sku: SKU of product, same as product_id
 * @param properties.fullLook: Send an additional variable that returns all the SKU's of the products when a full look is added to Wishlist (lookbuilder).
 * @param properties.value: Price * Quantity
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4a040kO3L}
 */
export function productViewed(properties: ProductViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  properties.listId !== undefined && properties.listId !== null ?
    eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId}) :
    eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: null});
  properties.itemListName !== undefined && properties.itemListName !== null ?
    eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName}) :
    eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: null});
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
  eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name});
  properties.variant !== undefined && properties.variant !== null ?
    eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: properties.variant}) :
    eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: null});
  eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
  eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  properties.onlineMaterial !== undefined && properties.onlineMaterial !== null ?
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: properties.onlineMaterial}) :
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: null});
  properties.fitId !== undefined && properties.fitId !== null ?
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: properties.fitId}) :
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: null});
  eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
  properties.fullLook !== undefined && properties.fullLook !== null ?
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: properties.fullLook}) :
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: null});
  eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertPosition(properties.position));
    messages = messages.concat(assertValue(properties.value));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "4a040kO3L", "6c28c498787ac6d781f0074b04184111617cbc087cacbc9bd4528896d6f41c4d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("4a040kO3L", "Product Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Viewed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Viewed", eventProperties, "4a040kO3L", "6c28c498787ac6d781f0074b04184111617cbc087cacbc9bd4528896d6f41c4d");
    }
    // destination Segment
    Segment.logEvent("Product Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductViewedCmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  listId: string | null | undefined;
  itemListName: string | null | undefined;
  productId: string;
  category: string;
  affiliation: AffiliationValueType;
  name: string;
  variant: string | null | undefined;
  price: number;
  quantity: number;
  position: number;
  sku: string;
  value: number;
}
/**
 * Product Viewed: When landing an a PDP, or clicking on 'select size' in panel, event variant
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.listId: This describes the listname + unique location

for custommade it's: custom-made, should match regex: ^(|black-tie-package_(configurator|journal)|category_page|category_page_filtered|category-page-landing_(classic-suits|jackets-tuxedo|perennial-suits|shirts-tuxedo|suits-tuxedo|traveller-suits|tuxedo-suits|wedding-suits)|color-swatch_pdp|colour-swatch_pdp|custom-made|discover-our-collection_journal_(alter-your-fit|custom-made|the-hallmarks-of-a-quality-(shirt|shoe))|discover-the-new-collection_(csr-landing|newsletter-emailpreferences)|e\.thomas-collection_journal_e-thomas-mill|explore-the-collection_journal_(4-ply-traveller-collection|angelico-mill|candiani-mill|delfino-mill|drago-mill|fossati-mill|how-to-take-care-of-your-(knits|suits)|perennial-suits|reda-mill|reggiani-mill|relaxed-trousers-guide|weba-mill)|giftcard_landing|gift-wrapping_(cart|mini-cart)|most-popular_(store-detail|store-locator)|search|shop-(french-linen|indonesian-mother-of-pearl|the-look)_(journal_expedition-jort-the-tailoring-trail|custommade|lookbuilder_summary-screen|minicart|slider(_[1-7])?|wishlist)|view-similar-items_oos|wishlist|you-might-also-like_pdp)$
 * @param properties.itemListName: Name of list where products are shown

For custommade, it's 'custom made', should match regex: ^(|black tie package|category page|category page filtered|category page landing|color swatch|colour swatch|custom made|discover the new collection|explore the collection|gift wrapping|giftcard landing|most popular|search|shop the look|view similar items|wishlist|you might also like)$
 * @param properties.productId: SKU of product

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.category: Product Category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
Will be gift card for giftcard

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.variant: Should return size for all products except giftcard. For Giftcard should return 'physical' or 'electronic', should match regex: ^(|5|6|6\.5|7|7\.5|8|8\.5|9|9\.5|10|10\.5|11|12|13|14|14\s1\/2|15|15\s1\/2|15\s3\/4|16|16\s1\/2|17|17\s1\/2|18|18\s1\/2|19|22|23|24|25|26|27|28|29|30|32|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|50|52|54|56|58|60|62|75|85|90|94|95|98|102|105|106|110|114|118|14\s1\/2s|15\s1\/2l|16l|17\s1\/2l|17\s3\/4l|17l|18\s1\/2s|29\/32|30\/32|30l|30s|31\/32|31\/34|32\/32|32\/34|32l|32s|33\/32|33\/34|34\/32|34\/34|34l|34s|35\/34|35\/36|36\/34|36l|36s|37\/38|37l|37s|38-7|38l|38s|39\/40|39-42|39-7|39l|39l\/40l|40-7|40l|40s|41\/42|41l|41l\/42l|42l|42s|43\/44|43-46|43l|43l\/44l|44l|44s|45\/46|46l|46s|47l|47s|48l|48s|52l|52s|56s|CustomMade|electronic|l|m|one-size|physical|s|xl|xs|xxl)$
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added to cart
 * @param properties.position: Position of product, should always start with 1 
 * @param properties.sku: SKU of product, same as product_id
 * @param properties.value: Price * Quantity
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4a040kO3L.JcE5rZjJL}
 */
export function productViewedCm(properties: ProductViewedCmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  properties.listId !== undefined && properties.listId !== null ?
    eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId}) :
    eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: null});
  properties.itemListName !== undefined && properties.itemListName !== null ?
    eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName}) :
    eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: null});
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
  eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name});
  properties.variant !== undefined && properties.variant !== null ?
    eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: properties.variant}) :
    eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: null});
  eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
  eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
  eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertPosition(properties.position));
    messages = messages.concat(assertValue(properties.value));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "4a040kO3L.JcE5rZjJL", "66ed56bde4be31dc451bbcf61ccca0d3bd9e706ee5b1e98abbfe1b9df7a5e9c3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("4a040kO3L.JcE5rZjJL", "Product Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Viewed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Viewed", eventProperties, "4a040kO3L.JcE5rZjJL", "66ed56bde4be31dc451bbcf61ccca0d3bd9e706ee5b1e98abbfe1b9df7a5e9c3");
    }
    // destination Segment
    Segment.logEvent("Product Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductAddedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  listId: string;
  itemListName: string;
  productId: string;
  category: string;
  affiliation: AffiliationValueType;
  name: string;
  variant: string | null | undefined;
  price: number;
  quantity: number;
  position: number;
  value: number;
  onlineMaterial: string | null | undefined;
  fitId: string | null | undefined;
  sku: string;
  fullLook: string | null | undefined;
}
/**
 * Product Added: When clicking on 'add to bag' on a PDP, panel or increasing value on the cart page. 
for Custommade: when clicking on 'add to bag' on the summary screen.
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.listId: This describes the listname + unique location

for custommade it's: custom-made, should match regex: ^(|black-tie-package_(configurator|journal)|category_page|category_page_filtered|category-page-landing_(classic-suits|jackets-tuxedo|perennial-suits|shirts-tuxedo|suits-tuxedo|traveller-suits|tuxedo-suits|wedding-suits)|color-swatch_pdp|colour-swatch_pdp|custom-made|discover-our-collection_journal_(alter-your-fit|custom-made|the-hallmarks-of-a-quality-(shirt|shoe))|discover-the-new-collection_(csr-landing|newsletter-emailpreferences)|e\.thomas-collection_journal_e-thomas-mill|explore-the-collection_journal_(4-ply-traveller-collection|angelico-mill|candiani-mill|delfino-mill|drago-mill|fossati-mill|how-to-take-care-of-your-(knits|suits)|perennial-suits|reda-mill|reggiani-mill|relaxed-trousers-guide|weba-mill)|giftcard_landing|gift-wrapping_(cart|mini-cart)|most-popular_(store-detail|store-locator)|search|shop-(french-linen|indonesian-mother-of-pearl|the-look)_(journal_expedition-jort-the-tailoring-trail|custommade|lookbuilder_summary-screen|minicart|slider(_[1-7])?|wishlist)|view-similar-items_oos|wishlist|you-might-also-like_pdp)$
 * @param properties.itemListName: Name of list where products are shown

For custommade, it's 'custom made', should match regex: ^(|black tie package|category page|category page filtered|category page landing|color swatch|colour swatch|custom made|discover the new collection|explore the collection|gift wrapping|giftcard landing|most popular|search|shop the look|view similar items|wishlist|you might also like)$
 * @param properties.productId: SKU of product

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.category: Product Category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
Will be gift card for giftcard

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.variant: Should return size for all products except giftcard. For Giftcard should return 'physical' or 'electronic', should match regex: ^(|5|6|6\.5|7|7\.5|8|8\.5|9|9\.5|10|10\.5|11|12|13|14|14\s1\/2|15|15\s1\/2|15\s3\/4|16|16\s1\/2|17|17\s1\/2|18|18\s1\/2|19|22|23|24|25|26|27|28|29|30|32|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|50|52|54|56|58|60|62|75|85|90|94|95|98|102|105|106|110|114|118|14\s1\/2s|15\s1\/2l|16l|17\s1\/2l|17\s3\/4l|17l|18\s1\/2s|29\/32|30\/32|30l|30s|31\/32|31\/34|32\/32|32\/34|32l|32s|33\/32|33\/34|34\/32|34\/34|34l|34s|35\/34|35\/36|36\/34|36l|36s|37\/38|37l|37s|38-7|38l|38s|39\/40|39-42|39-7|39l|39l\/40l|40-7|40l|40s|41\/42|41l|41l\/42l|42l|42s|43\/44|43-46|43l|43l\/44l|44l|44s|45\/46|46l|46s|47l|47s|48l|48s|52l|52s|56s|CustomMade|electronic|l|m|one-size|physical|s|xl|xs|xxl)$
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added to cart
 * @param properties.position: Position of product, should always start with 1 
 * @param properties.value: Price * Quantity
 * @param properties.onlineMaterial: Material of product
 * @param properties.fitId: no description
 * @param properties.sku: SKU of product, same as product_id
 * @param properties.fullLook: Send an additional variable that returns all the SKU's of the products when a full look is added to Wishlist (lookbuilder).
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/0mNPEK9jV}
 */
export function productAdded(properties: ProductAddedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
  eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
  eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name});
  properties.variant !== undefined && properties.variant !== null ?
    eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: properties.variant}) :
    eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: null});
  eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
  eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
  properties.onlineMaterial !== undefined && properties.onlineMaterial !== null ?
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: properties.onlineMaterial}) :
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: null});
  properties.fitId !== undefined && properties.fitId !== null ?
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: properties.fitId}) :
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: null});
  eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
  properties.fullLook !== undefined && properties.fullLook !== null ?
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: properties.fullLook}) :
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: null});
  eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertPosition(properties.position));
    messages = messages.concat(assertValue(properties.value));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "0mNPEK9jV", "dea14037ddb89282869df116805b386ecd28932a5dbc5c6a29425bcdf9384d01", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Added", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("0mNPEK9jV", "Product Added", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Added': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Added", eventProperties, "0mNPEK9jV", "dea14037ddb89282869df116805b386ecd28932a5dbc5c6a29425bcdf9384d01");
    }
    // destination Segment
    Segment.logEvent("Product Added", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductAddedCmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  listId: string;
  itemListName: string;
  productId: string;
  category: string;
  affiliation: AffiliationValueType;
  name: string;
  price: number;
  quantity: number;
  position: number;
  value: number;
  sku: string;
}
/**
 * Product Added: When clicking on 'add to bag' on a PDP, panel or increasing value on the cart page. 
for Custommade: when clicking on 'add to bag' on the summary screen., event variant
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.listId: This describes the listname + unique location

for custommade it's: custom-made, should match regex: ^(|black-tie-package_(configurator|journal)|category_page|category_page_filtered|category-page-landing_(classic-suits|jackets-tuxedo|perennial-suits|shirts-tuxedo|suits-tuxedo|traveller-suits|tuxedo-suits|wedding-suits)|color-swatch_pdp|colour-swatch_pdp|custom-made|discover-our-collection_journal_(alter-your-fit|custom-made|the-hallmarks-of-a-quality-(shirt|shoe))|discover-the-new-collection_(csr-landing|newsletter-emailpreferences)|e\.thomas-collection_journal_e-thomas-mill|explore-the-collection_journal_(4-ply-traveller-collection|angelico-mill|candiani-mill|delfino-mill|drago-mill|fossati-mill|how-to-take-care-of-your-(knits|suits)|perennial-suits|reda-mill|reggiani-mill|relaxed-trousers-guide|weba-mill)|giftcard_landing|gift-wrapping_(cart|mini-cart)|most-popular_(store-detail|store-locator)|search|shop-(french-linen|indonesian-mother-of-pearl|the-look)_(journal_expedition-jort-the-tailoring-trail|custommade|lookbuilder_summary-screen|minicart|slider(_[1-7])?|wishlist)|view-similar-items_oos|wishlist|you-might-also-like_pdp)$
 * @param properties.itemListName: Name of list where products are shown

For custommade, it's 'custom made', should match regex: ^(|black tie package|category page|category page filtered|category page landing|color swatch|colour swatch|custom made|discover the new collection|explore the collection|gift wrapping|giftcard landing|most popular|search|shop the look|view similar items|wishlist|you might also like)$
 * @param properties.productId: SKU of product

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.category: Product Category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
Will be gift card for giftcard

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added to cart
 * @param properties.position: Position of product, should always start with 1 
 * @param properties.value: Price * Quantity
 * @param properties.sku: SKU of product, same as product_id
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/0mNPEK9jV.a9tlg0c-F}
 */
export function productAddedCm(properties: ProductAddedCmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
  eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
  eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name});
  eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
  eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
  eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertPosition(properties.position));
    messages = messages.concat(assertValue(properties.value));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "0mNPEK9jV.a9tlg0c-F", "525873c39dd22d1e940cc02e17b27ac72aa84766c7e40cf47ba320b582107607", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Added", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("0mNPEK9jV.a9tlg0c-F", "Product Added", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Added': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Added", eventProperties, "0mNPEK9jV.a9tlg0c-F", "525873c39dd22d1e940cc02e17b27ac72aa84766c7e40cf47ba320b582107607");
    }
    // destination Segment
    Segment.logEvent("Product Added", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PageLoadedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  customDestinationPageName_: string;
  localeVisited: string;
}
/**
 * Page Loaded: When a page or a virtual page is loaded
for custommade: products_cart and referrer not needed
 * 
 * When to trigger this event:
 * 1. Custommade Suits page 1:

url: 
suitsupply.com/custommade/suit/fabric
location_id: suitsupply.com/en-nl/custommade/suit/fabric
title: "Select your fabric"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4l0ZskS226/trigger/ilo2Fao9X
 * 2. Custommade Suits - jacket:

url: 
suitsupply.com/custommade/suit/jacket
location_id: suitsupply.com/en-nl/custommade/suit/jacket
title: "Customize your jacket"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4l0ZskS226/trigger/EJGPRxCWM
 * 3. Custommade Suits - jacket - Style:

url: 
suitsupply.com/custommade/suit/jacket/style
location_id: suitsupply.com/en-nl/custommade/suit/jacket/style
title: customize your jacket style
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4l0ZskS226/trigger/8DnMiHdiv
 * 4. Custommade Suits - trousers - Style:

url: 
suitsupply.com/custommade/suit/trousers/style
location_id: suitsupply.com/en-nl/custommade/suit/trousers/style
title: customize your trousers style
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4l0ZskS226/trigger/Y-U_FnScC
 * 5. Custommade Suits - trousers:

url: 
suitsupply.com/custommade/suit/trousers
location_id: suitsupply.com/en-nl/custommade/suit/trousers
title: "Customize your trousers"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4l0ZskS226/trigger/lDHJUY7uw
 * 6. Custommade Suits - Waistcoat:

url: 
suitsupply.com/custommade/suit/waistcoat
location_id: suitsupply.com/en-nl/custommade/suit/waistcoat
title: "Customize your waistcoat"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4l0ZskS226/trigger/hGYSO6MWH
 * 7. Custommade Suits - summary

url: 
suitsupply.com/custommade/suit/summary/
location_id: suitsupply.com/en-nl/custommade/suit/summary/
title: "Your summary"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4l0ZskS226/trigger/tB6E44bgl
 * 8. Title: instore - checkin - login
url: https://suitsupply.com/en-nl//instore/checkin-login/
location_id: https://suitsupply.com/en-nl//instore/checkin-login/
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4l0ZskS226/trigger/GzKmdfzMs
 * 9. title: instore - checkin - register
location_id: https://suitsupply.com/en-nl/instore/checkin-register/
url: https://suitsupply.com/instore/checkin-register/
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4l0ZskS226/trigger/h5T0sz4zf
 * 10. title: instore - checkin - long succeeded
url: https://suitsupply.com/instore/checkin-succeeded-wait-long/
location_id: https://suitsupply.com/en-nl/instore/checkin-succeeded-wait-long/
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4l0ZskS226/trigger/WL4lVMb0g
 * 11. title: instore - checkin - short succeeded
url: https://suitsupply.com/instore/checkin-succeeded-wait-short/
location_id: https://suitsupply.com/en-nl/instore/checkin-succeeded-wait-short/
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4l0ZskS226/trigger/Djt5Cknvx
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.localeVisited: Locale visited, for example en-us or es-us
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4l0ZskS226}
 */
export function pageLoaded(properties: PageLoadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "QSRXqGwpG", name: "locale_visited", value: properties.localeVisited});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "4l0ZskS226", "98c2b6dbf7fd6c9c3b586e9f0f868c8c01bb88cde2d1f8e422d566a22e2affe2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Page Loaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("4l0ZskS226", "Page Loaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    // destination Segment
    if (Segment.logPage) {
      Segment.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface PageLoadedVirtualPageViewProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  customDestinationPageName_: string;
  localeVisited: string;
}
/**
 * Page Loaded: When a page or a virtual page is loaded
for custommade: products_cart and referrer not needed, event variant
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.localeVisited: Locale visited, for example en-us or es-us
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4l0ZskS226.zXISHUvOO}
 */
export function pageLoadedVirtualPageView(properties: PageLoadedVirtualPageViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "QSRXqGwpG", name: "locale_visited", value: properties.localeVisited});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "4l0ZskS226.zXISHUvOO", "2dae1a2d3d4a8ad0f9f27c2a7ac6f3db8c79d07b9b5af991ac746cf44e35401a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Page Loaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("4l0ZskS226.zXISHUvOO", "Page Loaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    // destination Segment
    if (Segment.logPage) {
      Segment.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface PageLoadedCmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  customDestinationPageName_: string;
  localeVisited: string;
}
/**
 * Page Loaded: When a page or a virtual page is loaded
for custommade: products_cart and referrer not needed, event variant
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.localeVisited: Locale visited, for example en-us or es-us
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/4l0ZskS226.L14A1aHRF}
 */
export function pageLoadedCm(properties: PageLoadedCmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "QSRXqGwpG", name: "locale_visited", value: properties.localeVisited});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "4l0ZskS226.L14A1aHRF", "3dbf800253f5c6ce8f502ea0652dea5e8b1563bc11fac14ec47c22ae4083ade5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Page Loaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("4l0ZskS226.L14A1aHRF", "Page Loaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    // destination Segment
    if (Segment.logPage) {
      Segment.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface FabricGroupSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * fabric_group_select: Firing when the fabric group is clicked.

cm_option: {{group option clicked}} example: most-popular|all-fabrics|black|blue|brown
event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When clicking on one of the fabric groups.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/n9-r79CTrs/trigger/tfV_mOetX
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/n9-r79CTrs}
 */
export function fabricGroupSelect(properties: FabricGroupSelectProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "n9-r79CTrs", "92cb80bf737ef5d8c9915d4301591d4367d3814c14f55133647247517ed46237", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("fabric_group_select", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("n9-r79CTrs", "fabric_group_select", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("fabric_group_select", eventProperties, "n9-r79CTrs", "92cb80bf737ef5d8c9915d4301591d4367d3814c14f55133647247517ed46237");
    }
    // destination Segment
    Segment.logEvent("fabric_group_select", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FabricOptionSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * fabric_option_select: Firing when the fabric option is clicked.

- cm_option: {{clicked fabric group}}_{{clicked color code}} example: most-popular_black-pure-s110s-wool|black_black-wool-stretch

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When a fabric is selected
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/yhrlHOrZQ/trigger/5QvaRyd3N
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/yhrlHOrZQ}
 */
export function fabricOptionSelect(properties: FabricOptionSelectProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "yhrlHOrZQ", "f46a8e2d95e6612e8be23ba7f8acab23b08470ce6f6d88473350dcd17bf1740a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("fabric_option_select", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("yhrlHOrZQ", "fabric_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("fabric_option_select", eventProperties, "yhrlHOrZQ", "f46a8e2d95e6612e8be23ba7f8acab23b08470ce6f6d88473350dcd17bf1740a");
    }
    // destination Segment
    Segment.logEvent("fabric_option_select", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FabricOptionConfirmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * fabric_option_confirm: Firing when the fabric option is confirmed.

- cm_option: {{clicked fabric group}}_{{clicked color code}} example: most-popular_black-pure-s110s-wool|black_black-wool-stretch

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When a fabric option is confirmed.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/kCtNIDRn2/trigger/dIhRahME5
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/kCtNIDRn2}
 */
export function fabricOptionConfirm(properties: FabricOptionConfirmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "kCtNIDRn2", "0453b7a06e77a8e581c89538e8696ab77fc868cd467c63fe7713ede3d79a971f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("fabric_option_confirm", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("kCtNIDRn2", "fabric_option_confirm", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("fabric_option_confirm", eventProperties, "kCtNIDRn2", "0453b7a06e77a8e581c89538e8696ab77fc868cd467c63fe7713ede3d79a971f");
    }
    // destination Segment
    Segment.logEvent("fabric_option_confirm", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface StyleOptionSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  btcOption: string | null | undefined;
}
/**
 * style_option_select: Firing when the style option is selected.

- cm_option:{{selected option}} example: business|casual|classic-double-breasted

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When a style is selected.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/eRtiLrwzB/trigger/r-pdwSlnh
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.btcOption: no description
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/eRtiLrwzB}
 */
export function styleOptionSelect(properties: StyleOptionSelectProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.btcOption !== undefined && properties.btcOption !== null ?
    eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: properties.btcOption}) :
    eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "eRtiLrwzB", "8622143f54bbcf6d95ff354fba512fe69321eec0fedd25f3eeea0b91232dbf54", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("style_option_select", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("eRtiLrwzB", "style_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("style_option_select", eventProperties, "eRtiLrwzB", "8622143f54bbcf6d95ff354fba512fe69321eec0fedd25f3eeea0b91232dbf54");
    }
    // destination Segment
    Segment.logEvent("style_option_select", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface StyleOptionSelectCmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * style_option_select: Firing when the style option is selected.

- cm_option:{{selected option}} example: business|casual|classic-double-breasted

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket, event variant
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/eRtiLrwzB.pxxFF_WKY}
 */
export function styleOptionSelectCm(properties: StyleOptionSelectCmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "eRtiLrwzB.pxxFF_WKY", "5b2abd9924c890edd04825b2337a5f8daeb96167b9d03c7ebb8ed47c0ab7fc55", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("style_option_select", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("eRtiLrwzB.pxxFF_WKY", "style_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("style_option_select", eventProperties, "eRtiLrwzB.pxxFF_WKY", "5b2abd9924c890edd04825b2337a5f8daeb96167b9d03c7ebb8ed47c0ab7fc55");
    }
    // destination Segment
    Segment.logEvent("style_option_select", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface StyleOptionConfirmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * style_option_confirm: Firing when the style option is selected.

- cm_option:{{selected option}} example: business|casual|classic-double-breasted

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When a style is confirmed.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/yhBSr917Q/trigger/BXyfxriJU
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/yhBSr917Q}
 */
export function styleOptionConfirm(properties: StyleOptionConfirmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "yhBSr917Q", "ce598b6014a35e5a6d29e140fa05c4182ad5887df024e26ead641c294b096df3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("style_option_confirm", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("yhBSr917Q", "style_option_confirm", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("style_option_confirm", eventProperties, "yhBSr917Q", "ce598b6014a35e5a6d29e140fa05c4182ad5887df024e26ead641c294b096df3");
    }
    // destination Segment
    Segment.logEvent("style_option_confirm", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BasicSectionSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * basic_section_select: Firing when the style option is selected.

- cm_option: {{clicked option}} example: lining|buttons|monogram|lapel|canvas

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When clicking on a basic section
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/kROaY5HfW/trigger/BeDVPhYNO
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/kROaY5HfW}
 */
export function basicSectionSelect(properties: BasicSectionSelectProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "kROaY5HfW", "ff0348948316417297eb28ddca6286816a74c7ac9108881162e690a43c9c04eb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("basic_section_select", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("kROaY5HfW", "basic_section_select", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("basic_section_select", eventProperties, "kROaY5HfW", "ff0348948316417297eb28ddca6286816a74c7ac9108881162e690a43c9c04eb");
    }
    // destination Segment
    Segment.logEvent("basic_section_select", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BasicOptionSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * basic_option_select: Firing when the style option is selected.

- cm_option: {{section}}_{{subsection}}_{{clicked option}} example: lining_type_half-lined|lining_color_paisley-purple|buttons_button_dark-brown| buttons_sleeve_5-kissing-buttons

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When selecting a basic option
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/SOhuqk-QK/trigger/Cyt_4Iun_
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/SOhuqk-QK}
 */
export function basicOptionSelect(properties: BasicOptionSelectProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "SOhuqk-QK", "4eb7087a04aa8357335059a648541f69f90da08fe5f9a05f393e716862cc92fb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("basic_option_select", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("SOhuqk-QK", "basic_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("basic_option_select", eventProperties, "SOhuqk-QK", "4eb7087a04aa8357335059a648541f69f90da08fe5f9a05f393e716862cc92fb");
    }
    // destination Segment
    Segment.logEvent("basic_option_select", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BasicOptionConfirmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * basic_option_confirm: Firing when the style option is selected.

- cm_option: {{section}}_{{subsection}}_{{clicked option}} example: lining_type_half-lined|lining_color_paisley-purple|buttons_button_dark-brown| buttons_sleeve_5-kissing-buttons

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When confirming a basic option
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/1fKqIoncf/trigger/S-7TXme7N
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/1fKqIoncf}
 */
export function basicOptionConfirm(properties: BasicOptionConfirmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1fKqIoncf", "c539063e46a0c52aeff32018eb2ae07ef438c6abc2dd050942dfaefbbaee01c7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("basic_option_confirm", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1fKqIoncf", "basic_option_confirm", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("basic_option_confirm", eventProperties, "1fKqIoncf", "c539063e46a0c52aeff32018eb2ae07ef438c6abc2dd050942dfaefbbaee01c7");
    }
    // destination Segment
    Segment.logEvent("basic_option_confirm", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ShowAdvancedOptionsProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * show_advanced_options: When clicking on 'Advanced options' 

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket

 * 
 * When to trigger this event:
 * 1. When clicking on the 'Advanced options' button
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/By2FfLdNT/trigger/OB37diEFb
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/By2FfLdNT}
 */
export function showAdvancedOptions(properties: ShowAdvancedOptionsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "By2FfLdNT", "e9a5593fec4be55bebecd8a82c4ae9b7ab56f43cf0870f53780ace8ec976ba0d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("show_advanced_options", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("By2FfLdNT", "show_advanced_options", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("show_advanced_options", eventProperties, "By2FfLdNT", "e9a5593fec4be55bebecd8a82c4ae9b7ab56f43cf0870f53780ace8ec976ba0d");
    }
    // destination Segment
    Segment.logEvent("show_advanced_options", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ShowAdvancedOptionsSpProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * show_advanced_options: When clicking on 'Advanced options' 

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket, variant description: event_category: sp_interactions
event_location: sp_{{category}}_{{subcategory}} or sp_{{subcategory}}
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/By2FfLdNT.647KbMonc}
 */
export function showAdvancedOptionsSp(properties: ShowAdvancedOptionsSpProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "By2FfLdNT.647KbMonc", "5cb05e5ac46fc31560479e3aa74763972f8a2934ce4c816d7ec4aefa6d3e2440", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("show_advanced_options", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("By2FfLdNT.647KbMonc", "show_advanced_options", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("show_advanced_options", eventProperties, "By2FfLdNT.647KbMonc", "5cb05e5ac46fc31560479e3aa74763972f8a2934ce4c816d7ec4aefa6d3e2440");
    }
    // destination Segment
    Segment.logEvent("show_advanced_options", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AdvancedSectionSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * advanced_section_select: Firing when the advanced style option is selected.

- cm_option: {{clicked option}} example: shoulder|pockets|amf

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When clicking on an advanced section
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/PM2yXCSNi/trigger/UQJNOV2IK
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/PM2yXCSNi}
 */
export function advancedSectionSelect(properties: AdvancedSectionSelectProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "PM2yXCSNi", "4da2c761238d1bd158b1b4974497c2a5aeb8f4176fbc4ba29132948ef25b5e66", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("advanced_section_select", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("PM2yXCSNi", "advanced_section_select", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("advanced_section_select", eventProperties, "PM2yXCSNi", "4da2c761238d1bd158b1b4974497c2a5aeb8f4176fbc4ba29132948ef25b5e66");
    }
    // destination Segment
    Segment.logEvent("advanced_section_select", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AdvancedOptionSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * advanced_option_select: Firing when the advanced option is selected.

- cm_option: {{section}}_{{subsection}}_{{clicked option}} example: lining_type_half-lined|lining_color_paisley-purple|buttons_button_dark-brown| buttons_sleeve_5-kissing-buttons

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When selecting an advanced option
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/8FF8EjEs5/trigger/NaTGtY3s3
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/8FF8EjEs5}
 */
export function advancedOptionSelect(properties: AdvancedOptionSelectProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8FF8EjEs5", "5851325890a60cdfc4bb751121eda88b6e4d0dd20b56c9934c3d85149b3068f2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("advanced_option_select", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8FF8EjEs5", "advanced_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("advanced_option_select", eventProperties, "8FF8EjEs5", "5851325890a60cdfc4bb751121eda88b6e4d0dd20b56c9934c3d85149b3068f2");
    }
    // destination Segment
    Segment.logEvent("advanced_option_select", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AdvancedOptionConfirmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * advanced_option_confirm: Firing when the advanced option is confirmed.

- cm_option: {{section}}_{{subsection}}_{{clicked option}} example: lining_type_half-lined|lining_color_paisley-purple|buttons_button_dark-brown| buttons_sleeve_5-kissing-buttons

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When confirming an advanced option
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/knCkEc_gS/trigger/YHIZ-tjRx
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/knCkEc_gS}
 */
export function advancedOptionConfirm(properties: AdvancedOptionConfirmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "knCkEc_gS", "22bf71ac77a78bd714318bb6b455d0ea869116cbb6fdc277f72f6e1eaba8fc96", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("advanced_option_confirm", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("knCkEc_gS", "advanced_option_confirm", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("advanced_option_confirm", eventProperties, "knCkEc_gS", "22bf71ac77a78bd714318bb6b455d0ea869116cbb6fdc277f72f6e1eaba8fc96");
    }
    // destination Segment
    Segment.logEvent("advanced_option_confirm", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SummarySeeMinusallMinusdetailsProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * summary_see-all-details: When clicking on 'See all details' icon on the summary screen 

- event_location: cm_{{category}}_summary example cm_suits_summary
- cm_option: jacket|trousers|fabric
 * 
 * When to trigger this event:
 * 1. When clicking on the 'See all details' button on the summary page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/v4Qx9DLbW/trigger/rDxOatk1m
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/v4Qx9DLbW}
 */
export function summarySeeAllDetails(properties: SummarySeeMinusallMinusdetailsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "v4Qx9DLbW", "30a5488f74b2115f9a8198bb5d3537d89efd952b370e478e25569fdb1504f926", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("summary_see-all-details", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("v4Qx9DLbW", "summary_see-all-details", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("summary_see-all-details", eventProperties, "v4Qx9DLbW", "30a5488f74b2115f9a8198bb5d3537d89efd952b370e478e25569fdb1504f926");
    }
    // destination Segment
    Segment.logEvent("summary_see-all-details", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SummaryFinishMinusinMinusstoreProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * summary_finish-in-store: When clicking on 'Finish in store' button on the summary screen 

- event_location: cm_summary_{{category}} example cm_summary_suits
 * 
 * When to trigger this event:
 * 1. When clicking on the 'Finish in store' button on the summary page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/w6DzGePbE/trigger/D-14YS-IO
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/w6DzGePbE}
 */
export function summaryFinishInStore(properties: SummaryFinishMinusinMinusstoreProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "w6DzGePbE", "1e76cbd6d749bdc25b6a9eaa707e234bef274bd1dc53147861fb1ad6391c88ce", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("summary_finish-in-store", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("w6DzGePbE", "summary_finish-in-store", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("summary_finish-in-store", eventProperties, "w6DzGePbE", "1e76cbd6d749bdc25b6a9eaa707e234bef274bd1dc53147861fb1ad6391c88ce");
    }
    // destination Segment
    Segment.logEvent("summary_finish-in-store", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SummarySaveMinusandMinusshareProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * summary_save-and-share: When clicking on 'Save and Share' button on the summary screen 

- event_location: cm_summary_{{category}} example cm_summary_suits_jacket
 * 
 * When to trigger this event:
 * 1. When clicking on 'Save and Share' button on the summary screen 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/KZNxeK-An/trigger/uxKyd_op-
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/KZNxeK-An}
 */
export function summarySaveAndShare(properties: SummarySaveMinusandMinusshareProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "KZNxeK-An", "03f82f0830135842e88f7be6391bb0ef2ad3c9881fd687daeab171461bf9c5fb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("summary_save-and-share", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("KZNxeK-An", "summary_save-and-share", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("summary_save-and-share", eventProperties, "KZNxeK-An", "03f82f0830135842e88f7be6391bb0ef2ad3c9881fd687daeab171461bf9c5fb");
    }
    // destination Segment
    Segment.logEvent("summary_save-and-share", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SummaryEditProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * summary_edit: When clicking on 'edit' icon on the summary screen 

- event_location: cm_{{category}}_summaryexample cm_suits_summary
- cm_option: jacket|trousers|waistcoat

 * 
 * When to trigger this event:
 * 1. When clicking on 'edit' icon on the summary screen 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/KNnHKBbfV/trigger/-TISpFDBA
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/KNnHKBbfV}
 */
export function summaryEdit(properties: SummaryEditProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "KNnHKBbfV", "15acf1ab704f3c41b34cd4ff8eac497bb36ff04b2b2c1179073c16bd02940a6a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("summary_edit", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("KNnHKBbfV", "summary_edit", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("summary_edit", eventProperties, "KNnHKBbfV", "15acf1ab704f3c41b34cd4ff8eac497bb36ff04b2b2c1179073c16bd02940a6a");
    }
    // destination Segment
    Segment.logEvent("summary_edit", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FabricFilterProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * fabric_filter: When clicking on 'filter' icon on the fabric section

- cm_option: {{selected fabric group }}_{{selection option}}_{{selected choice}} example: most-popular_color_blue|all-fabrics_season_fall-winter

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When clicking on 'filter' icon on the fabric section screen 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/li0ZEZ5ir/trigger/Lh0uqC6Vz
 * 2. When clicking on 'filter' icon on the fabric section screen 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/li0ZEZ5ir/trigger/4HSim5_oA1YWnFh0R2py2
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/li0ZEZ5ir}
 */
export function fabricFilter(properties: FabricFilterProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "li0ZEZ5ir", "71e383e2b8d0a21fbd441ef175da051127141d72f1fac388f7b23bf1d87bc7df", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("fabric_filter", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("li0ZEZ5ir", "fabric_filter", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("fabric_filter", eventProperties, "li0ZEZ5ir", "71e383e2b8d0a21fbd441ef175da051127141d72f1fac388f7b23bf1d87bc7df");
    }
    // destination Segment
    Segment.logEvent("fabric_filter", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FabricInformationProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * fabric_information: When clicking on the 'information' icon on the fabric section

- cm_option: {{selected fabric group }}

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When clicking on the 'information' icon on the fabric section
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/tehuWAxI2/trigger/__l2YufBO
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/tehuWAxI2}
 */
export function fabricInformation(properties: FabricInformationProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "tehuWAxI2", "1fc73335dbad5b969d576a7a222b081f4eff768493c887ee8384d8ad6bb1c59f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("fabric_information", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("tehuWAxI2", "fabric_information", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("fabric_information", eventProperties, "tehuWAxI2", "1fc73335dbad5b969d576a7a222b081f4eff768493c887ee8384d8ad6bb1c59f");
    }
    // destination Segment
    Segment.logEvent("fabric_information", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustommadeDoneProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * custommade_done: Firing when the 'done' button is clicked.

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When clicking on the 'done' button in the interface
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/ribVSDo30/trigger/h-CHpb7QX
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/ribVSDo30}
 */
export function custommadeDone(properties: CustommadeDoneProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ribVSDo30", "a37d0324d36b4de9fa555290cd2384cebd7ba68cbddc7d98ebf3c47c8d2642df", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("custommade_done", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ribVSDo30", "custommade_done", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("custommade_done", eventProperties, "ribVSDo30", "a37d0324d36b4de9fa555290cd2384cebd7ba68cbddc7d98ebf3c47c8d2642df");
    }
    // destination Segment
    Segment.logEvent("custommade_done", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface StyleOptionChangeProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * style_option_change: Firing when the style change/edit is selected.

- cm_option:{{selected option}} example: business|casual|classic-double-breasted

- event_location: {{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When the option to change the style is clicked.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/RxyJeDhDH/trigger/18NhXj3B6
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/RxyJeDhDH}
 */
export function styleOptionChange(properties: StyleOptionChangeProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "RxyJeDhDH", "496cdb08435db49d8003f7782cfb7a3eb58e2435150d62c4f36a0879376643c9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("style_option_change", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("RxyJeDhDH", "style_option_change", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("style_option_change", eventProperties, "RxyJeDhDH", "496cdb08435db49d8003f7782cfb7a3eb58e2435150d62c4f36a0879376643c9");
    }
    // destination Segment
    Segment.logEvent("style_option_change", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface StyleOptionChangeConfirmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * style_option_change_confirm: Firing when the pop up 'change style' is clicked.

- cm_option: {{selected option}} example: business|casual|classic-double-breasted

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When the option to change the style is confirmed.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/EvgoQxQSE/trigger/R0LLZPLto
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/EvgoQxQSE}
 */
export function styleOptionChangeConfirm(properties: StyleOptionChangeConfirmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "EvgoQxQSE", "938232fc1b16314b0b38ede6aee5f569b2146bc9de714bcf15c7ce3ca14a8638", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("style_option_change_confirm", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("EvgoQxQSE", "style_option_change_confirm", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("style_option_change_confirm", eventProperties, "EvgoQxQSE", "938232fc1b16314b0b38ede6aee5f569b2146bc9de714bcf15c7ce3ca14a8638");
    }
    // destination Segment
    Segment.logEvent("style_option_change_confirm", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface StyleOptionChangeCancelProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * style_option_change_cancel: Firing when the pop up 'change style' is cancelled.

- cm_option: {{selected option}} example: business|casual|classic-double-breasted

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When the option to change the style is cancelled.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/viJG3zwB_/trigger/cAfAKMRSv
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/viJG3zwB_}
 */
export function styleOptionChangeCancel(properties: StyleOptionChangeCancelProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "viJG3zwB_", "daf28431e2c80b56deb67eaf4d2cc547b8d632d114b88ea413514d08bda5cb52", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("style_option_change_cancel", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("viJG3zwB_", "style_option_change_cancel", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("style_option_change_cancel", eventProperties, "viJG3zwB_", "daf28431e2c80b56deb67eaf4d2cc547b8d632d114b88ea413514d08bda5cb52");
    }
    // destination Segment
    Segment.logEvent("style_option_change_cancel", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MonogramChangeProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * monogram_change: Firing when the style change/edit is clicked for monogram.

- cm_option: inside-jacket | underside-collar
- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When the option to change the monogram is clicked.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/tDyAgafIS/trigger/qftTWkj1F
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/tDyAgafIS}
 */
export function monogramChange(properties: MonogramChangeProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "tDyAgafIS", "0f0982d3c0c1ba705b6438c2bc6442c018de1ad2342c91d590f093b4364a2f27", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("monogram_change", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("tDyAgafIS", "monogram_change", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("monogram_change", eventProperties, "tDyAgafIS", "0f0982d3c0c1ba705b6438c2bc6442c018de1ad2342c91d590f093b4364a2f27");
    }
    // destination Segment
    Segment.logEvent("monogram_change", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MonogramDeleteProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * monogram_delete: Firing when the style delete is clicked for monogram.

- cm_option: inside-jacket | underside-collar
- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When the option to delete the monogram is clicked.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/r3sFKgZyH/trigger/eUq_kPmq4
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/r3sFKgZyH}
 */
export function monogramDelete(properties: MonogramDeleteProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "r3sFKgZyH", "b28c1e73f5f0411a54a9fcad8c452c3f6dd250e6cc025f4b77bf7d10cf0d75a5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("monogram_delete", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("r3sFKgZyH", "monogram_delete", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("monogram_delete", eventProperties, "r3sFKgZyH", "b28c1e73f5f0411a54a9fcad8c452c3f6dd250e6cc025f4b77bf7d10cf0d75a5");
    }
    // destination Segment
    Segment.logEvent("monogram_delete", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MonogramDeleteConfirmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * monogram_delete_confirm: Firing when the style delete confirm is clicked for monogram.

- cm_option: inside-jacket | underside-collar
- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When the option to delete the monogram is confirmed.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/qTBkjBXqY/trigger/ov5G7NtnR
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/qTBkjBXqY}
 */
export function monogramDeleteConfirm(properties: MonogramDeleteConfirmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "qTBkjBXqY", "d212d93f11a7be27c568e890a498c5450d53aa668b2d68b540246a8bdf6fb9a8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("monogram_delete_confirm", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("qTBkjBXqY", "monogram_delete_confirm", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("monogram_delete_confirm", eventProperties, "qTBkjBXqY", "d212d93f11a7be27c568e890a498c5450d53aa668b2d68b540246a8bdf6fb9a8");
    }
    // destination Segment
    Segment.logEvent("monogram_delete_confirm", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MonogramDeleteCancelProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string | null | undefined;
}
/**
 * monogram_delete_cancel: Firing when the style delete confirm is clicked for monogram.

- cm_option: inside-jacket | underside-collar
- event_location: {{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When the option to delete the monogram is canceled.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/MnzppBlmD/trigger/qli6MQQ5w
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/MnzppBlmD}
 */
export function monogramDeleteCancel(properties: MonogramDeleteCancelProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmOption !== undefined && properties.cmOption !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "MnzppBlmD", "0a3f44b3a60d607eb92fb0a14b6ecb5ec84d3da9a321994d315a96514a6bd635", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("monogram_delete_cancel", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("MnzppBlmD", "monogram_delete_cancel", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("monogram_delete_cancel", eventProperties, "MnzppBlmD", "0a3f44b3a60d607eb92fb0a14b6ecb5ec84d3da9a321994d315a96514a6bd635");
    }
    // destination Segment
    Segment.logEvent("monogram_delete_cancel", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustommadeAddAdditionalProductProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
  cmOption: string;
}
/**
 * custommade_add_additional_product: Firing when an additional product is added for example 'add waistcoat'.

- cm_option: {{added product}} example: trousers|waistcoat|etc
- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket

 * 
 * When to trigger this event:
 * 1. When clicking on 'add waistcoat'
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/S1GxFnpMi/trigger/iNoJjzlsl
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/S1GxFnpMi}
 */
export function custommadeAddAdditionalProduct(properties: CustommadeAddAdditionalProductProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "S1GxFnpMi", "2a7efc2d2db0ca5be17de9133d64de47fb69e85992e1a773dd334a9c25848cc0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("custommade_add_additional_product", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("S1GxFnpMi", "custommade_add_additional_product", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("custommade_add_additional_product", eventProperties, "S1GxFnpMi", "2a7efc2d2db0ca5be17de9133d64de47fb69e85992e1a773dd334a9c25848cc0");
    }
    // destination Segment
    Segment.logEvent("custommade_add_additional_product", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SummaryFabricChangeProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * summary_fabric_change: Firing when the fabric change is clicked in the summary.

- event_location: cm_{{category}}_summary example: cm_suits_summary

 * 
 * When to trigger this event:
 * 1. When clicking on the 'edit' symbol next to the fabric on the summary page.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/xUkDNts_y/trigger/eRHcOEr94
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/xUkDNts_y}
 */
export function summaryFabricChange(properties: SummaryFabricChangeProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "xUkDNts_y", "5b2fa66f1565145565f57dde115ecefad486c8bed94f92c133ddc902adb562e6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("summary_fabric_change", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("xUkDNts_y", "summary_fabric_change", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("summary_fabric_change", eventProperties, "xUkDNts_y", "5b2fa66f1565145565f57dde115ecefad486c8bed94f92c133ddc902adb562e6");
    }
    // destination Segment
    Segment.logEvent("summary_fabric_change", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SummaryFabricChangeCancelProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * summary_fabric_change_cancel: Firing when the fabric change is being cancelled in the pop up.

- event_location: cm_{{category}}_summary example: cm_suits_summary


 * 
 * When to trigger this event:
 * 1. When clicking on the 'cancel' button on the pop up.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/enziNLq6O/trigger/qEL7CIQ9r
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/enziNLq6O}
 */
export function summaryFabricChangeCancel(properties: SummaryFabricChangeCancelProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "enziNLq6O", "b1247f09d31beaa32adfd8be3897c0e680f5f15ba23047445c69b14e7a8a949f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("summary_fabric_change_cancel", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("enziNLq6O", "summary_fabric_change_cancel", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("summary_fabric_change_cancel", eventProperties, "enziNLq6O", "b1247f09d31beaa32adfd8be3897c0e680f5f15ba23047445c69b14e7a8a949f");
    }
    // destination Segment
    Segment.logEvent("summary_fabric_change_cancel", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SummaryFabricChangeConfirmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * summary_fabric_change_confirm: Firing when the fabric change is being confirmed in the pop up.

- event_location: cm_{{category}}_summary example: cm_suits_summary


 * 
 * When to trigger this event:
 * 1. When clicking on the 'change fabric' button  on the pop up.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/RgoD9zNJW/trigger/LTYSJ9o2Q
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/RgoD9zNJW}
 */
export function summaryFabricChangeConfirm(properties: SummaryFabricChangeConfirmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "RgoD9zNJW", "e4c379daca3ecb92b07278d72b7d047ac4702f0d1986603da50e037c1029aa8b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("summary_fabric_change_confirm", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("RgoD9zNJW", "summary_fabric_change_confirm", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("summary_fabric_change_confirm", eventProperties, "RgoD9zNJW", "e4c379daca3ecb92b07278d72b7d047ac4702f0d1986603da50e037c1029aa8b");
    }
    // destination Segment
    Segment.logEvent("summary_fabric_change_confirm", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OverlayIntroShowedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLocation: EventLocationValueType;
}
/**
 * overlay_intro_showed: When clicking on 'Advanced options' 

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket

 * 
 * When to trigger this event:
 * 1. This events is fired when the panel is shown to the user. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/WkMkLaCOK/trigger/vTy2kaKns_
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/WkMkLaCOK}
 */
export function overlayIntroShowed(properties: OverlayIntroShowedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "cm_interactions"});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "WkMkLaCOK", "7821a60158bcb5f4e339f5ec64da8cb7abb49696b6f29b1d652b9c7f2ee04f66", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("overlay_intro_showed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("WkMkLaCOK", "overlay_intro_showed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("overlay_intro_showed", eventProperties, "WkMkLaCOK", "7821a60158bcb5f4e339f5ec64da8cb7abb49696b6f29b1d652b9c7f2ee04f66");
    }
    // destination Segment
    Segment.logEvent("overlay_intro_showed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OverlayFabricShowedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLocation: EventLocationValueType;
}
/**
 * overlay_fabric_showed: 
- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket

 * 
 * When to trigger this event:
 * 1. This events is fired when the panel is shown to the user. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/VtMcChfJQ/trigger/D6rPSkCdY7
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/VtMcChfJQ}
 */
export function overlayFabricShowed(properties: OverlayFabricShowedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "cm_interactions"});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "VtMcChfJQ", "b1064f60be6a6d4b69552ba20cd4e94fc0db47f9cd8691b5e517cdf9e43513b6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("overlay_fabric_showed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("VtMcChfJQ", "overlay_fabric_showed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("overlay_fabric_showed", eventProperties, "VtMcChfJQ", "b1064f60be6a6d4b69552ba20cd4e94fc0db47f9cd8691b5e517cdf9e43513b6");
    }
    // destination Segment
    Segment.logEvent("overlay_fabric_showed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OverlayStyleShowedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLocation: EventLocationValueType;
}
/**
 * overlay_style_showed: 
- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket

 * 
 * When to trigger this event:
 * 1. This events is fired when the panel is shown to the user. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/bv3WYQ5_P/trigger/zzDE3YdV1s
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/bv3WYQ5_P}
 */
export function overlayStyleShowed(properties: OverlayStyleShowedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "cm_interactions"});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "bv3WYQ5_P", "d58a18fc3c65147af5fe739f7ded85045a4dfcb791696a0003e82d4b0af4136c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("overlay_style_showed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("bv3WYQ5_P", "overlay_style_showed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("overlay_style_showed", eventProperties, "bv3WYQ5_P", "d58a18fc3c65147af5fe739f7ded85045a4dfcb791696a0003e82d4b0af4136c");
    }
    // destination Segment
    Segment.logEvent("overlay_style_showed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OverlayPersonaliseShowedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLocation: EventLocationValueType;
}
/**
 * overlay_personalise_showed: 
- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket

 * 
 * When to trigger this event:
 * 1. This events is fired when the panel is shown to the user. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/duFZ_1p9o/trigger/wpVFAA-xAu
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/duFZ_1p9o}
 */
export function overlayPersonaliseShowed(properties: OverlayPersonaliseShowedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "cm_interactions"});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "duFZ_1p9o", "b49e34fc7376b9ced4160fe498bb89a0d938ae29d2cac801f10547b4c221f2aa", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("overlay_personalise_showed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("duFZ_1p9o", "overlay_personalise_showed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("overlay_personalise_showed", eventProperties, "duFZ_1p9o", "b49e34fc7376b9ced4160fe498bb89a0d938ae29d2cac801f10547b4c221f2aa");
    }
    // destination Segment
    Segment.logEvent("overlay_personalise_showed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OverlayFitShowedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLocation: EventLocationValueType;
}
/**
 * overlay_fit_showed: 
- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket

 * 
 * When to trigger this event:
 * 1. This events is fired when the panel is shown to the user. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/chFpWACIF/trigger/SgzWbbS35s
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/chFpWACIF}
 */
export function overlayFitShowed(properties: OverlayFitShowedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "cm_interactions"});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "chFpWACIF", "63389a775ad8d2db5b9e7b41df4afc6ec4639c718fae9ca0f903ceedb65609fa", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("overlay_fit_showed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("chFpWACIF", "overlay_fit_showed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("overlay_fit_showed", eventProperties, "chFpWACIF", "63389a775ad8d2db5b9e7b41df4afc6ec4639c718fae9ca0f903ceedb65609fa");
    }
    // destination Segment
    Segment.logEvent("overlay_fit_showed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomMadeDesigningStartedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLocation: EventLocationValueType;
}
/**
 * custom_made_designing_started: Firing when the 'done' button is clicked.

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
- cm_option: overlay_intro|overlay_fabric|overlay_style|overlay_personalise|overlay_fit
 * 
 * When to trigger this event:
 * 1. When clicking on the 'Start designing' button
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/GyG7nyMfK/trigger/V4U57Xhsol
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/GyG7nyMfK}
 */
export function customMadeDesigningStarted(properties: CustomMadeDesigningStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "cm_interactions"});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "GyG7nyMfK", "e836d6b5e8098d76547b842d6ea9354c8be69171cbd00fa30722cab7b9194ec2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("custom_made_designing_started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("GyG7nyMfK", "custom_made_designing_started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("custom_made_designing_started", eventProperties, "GyG7nyMfK", "e836d6b5e8098d76547b842d6ea9354c8be69171cbd00fa30722cab7b9194ec2");
    }
    // destination Segment
    Segment.logEvent("custom_made_designing_started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomMadeOverlayExitedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLocation: EventLocationValueType;
}
/**
 * custom_made_overlay_exited: Firing when clicking outside the overlay to close it, without clicking on the 'start designing' button 

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
- cm_option: overlay_intro|overlay_fabric|overlay_style|overlay_personalise|overlay_fit
 * 
 * When to trigger this event:
 * 1. When clicking outside the overlays to close it.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/gE13pyuKe/trigger/4UITVsKUey
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/gE13pyuKe}
 */
export function customMadeOverlayExited(properties: CustomMadeOverlayExitedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "cm_interactions"});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "gE13pyuKe", "a70717629a862b0add2cc3df1a648d3818dc5d070c9190bfc16e16ca1a54a7c4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("custom_made_overlay_exited", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("gE13pyuKe", "custom_made_overlay_exited", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("custom_made_overlay_exited", eventProperties, "gE13pyuKe", "a70717629a862b0add2cc3df1a648d3818dc5d070c9190bfc16e16ca1a54a7c4");
    }
    // destination Segment
    Segment.logEvent("custom_made_overlay_exited", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * search_clicked: This event represents the action of clicking the search icon to initiate a search on the website
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/tJdEwNjByERhlix662YbL}
 */
export function searchClicked(properties: SearchClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "tJdEwNjByERhlix662YbL", "0d217804d49b101166e1a76f807052d807f3a1eb264441f04be39394b8526431", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("search_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("tJdEwNjByERhlix662YbL", "search_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("search_clicked", eventProperties, "tJdEwNjByERhlix662YbL", "0d217804d49b101166e1a76f807052d807f3a1eb264441f04be39394b8526431");
    }
    // destination Segment
    Segment.logEvent("search_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchClickedCustomMadeProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * search_clicked: This event represents the action of clicking the search icon to initiate a search on the website, variant description: This event represents when a user clicks in the Search to search for an option in the custom made tool
 * 
 * When to trigger this event:
 * 1. When the user clicks in the Search button on custom made tool
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/tJdEwNjByERhlix662YbL.rThksAXKqjq3pVcTtRFJW/trigger/iijYELtg_Y2ORJLUVujKR
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/tJdEwNjByERhlix662YbL.rThksAXKqjq3pVcTtRFJW}
 */
export function searchClickedCustomMade(properties: SearchClickedCustomMadeProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "tJdEwNjByERhlix662YbL.rThksAXKqjq3pVcTtRFJW", "6d751d8483acd78230e820eaea6a6940a23a8573e0eae6e982cdc46eab4e7383", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("search_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("tJdEwNjByERhlix662YbL.rThksAXKqjq3pVcTtRFJW", "search_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("search_clicked", eventProperties, "tJdEwNjByERhlix662YbL.rThksAXKqjq3pVcTtRFJW", "6d751d8483acd78230e820eaea6a6940a23a8573e0eae6e982cdc46eab4e7383");
    }
    // destination Segment
    Segment.logEvent("search_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomMadeCategoryChangedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * custom_made_category_changed: This event represents when a user clicks in a different category in the Custom Made tool
 * 
 * When to trigger this event:
 * 1. When the user clicks in a category
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/aiE2qvtr1j5gDEjP0wLIn/trigger/j4ecsWd0b3KWRcaEtD4LQ
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/aiE2qvtr1j5gDEjP0wLIn}
 */
export function customMadeCategoryChanged(properties: CustomMadeCategoryChangedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "aiE2qvtr1j5gDEjP0wLIn", "5fa95029e1b19223fdd516c1b15e01c3ddd1dec17f24480e9ee1a6a71b951bf1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("custom_made_category_changed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("aiE2qvtr1j5gDEjP0wLIn", "custom_made_category_changed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("custom_made_category_changed", eventProperties, "aiE2qvtr1j5gDEjP0wLIn", "5fa95029e1b19223fdd516c1b15e01c3ddd1dec17f24480e9ee1a6a71b951bf1");
    }
    // destination Segment
    Segment.logEvent("custom_made_category_changed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface EditSizePassportClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * edit_size_passport_clicked: This event represents when the user clicks to edit the Size Passport
 * 
 * When to trigger this event:
 * 1. When the user clicks to edit the Size Passport
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/qY0FT_xmPZPgEdEX48HhP/trigger/ybrT9aakCZFUYNBuYs8jg
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/qY0FT_xmPZPgEdEX48HhP}
 */
export function editSizePassportClicked(properties: EditSizePassportClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "qY0FT_xmPZPgEdEX48HhP", "05e394ff3cd92e946545d703bd4ec37856f6de5799ef52ce6cd612e31d7447b3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("edit_size_passport_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("qY0FT_xmPZPgEdEX48HhP", "edit_size_passport_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("edit_size_passport_clicked", eventProperties, "qY0FT_xmPZPgEdEX48HhP", "05e394ff3cd92e946545d703bd4ec37856f6de5799ef52ce6cd612e31d7447b3");
    }
    // destination Segment
    Segment.logEvent("edit_size_passport_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SizePassportLoginClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * size_passport_login_clicked: This event represents when the user clicks in the "Log In" on the Size Passport.
 * 
 * When to trigger this event:
 * 1. When the user clicks in the "Log In" on the Size Passport
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/0719RD72PoyWAf0iyKJHb/trigger/kG5h_9qgdR9IsR1wngz9l
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/0719RD72PoyWAf0iyKJHb}
 */
export function sizePassportLoginClicked(properties: SizePassportLoginClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "0719RD72PoyWAf0iyKJHb", "2475e088e5d675b1f96e20273e2b48ce31b8af399a96312794f83f37957e0f3c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("size_passport_login_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("0719RD72PoyWAf0iyKJHb", "size_passport_login_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("size_passport_login_clicked", eventProperties, "0719RD72PoyWAf0iyKJHb", "2475e088e5d675b1f96e20273e2b48ce31b8af399a96312794f83f37957e0f3c");
    }
    // destination Segment
    Segment.logEvent("size_passport_login_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SizePassportSizeGuideClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * size_passport_size_guide_clicked: This event represents when a user clicks in the "Size guide" button on the "Select your size" panel
 * 
 * When to trigger this event:
 * 1. When the user clicks in "Size guide" in the size passport tool
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/B0-4lwxAHnmpLXm3gerwz/trigger/8xkdqj5c6CWuZJD7P2-TZ
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/B0-4lwxAHnmpLXm3gerwz}
 */
export function sizePassportSizeGuideClicked(properties: SizePassportSizeGuideClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "B0-4lwxAHnmpLXm3gerwz", "d9274f9d04a42a617ceca8bfd9e3f8909142c8b2f4b674c2660774c39b28f821", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("size_passport_size_guide_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("B0-4lwxAHnmpLXm3gerwz", "size_passport_size_guide_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("size_passport_size_guide_clicked", eventProperties, "B0-4lwxAHnmpLXm3gerwz", "d9274f9d04a42a617ceca8bfd9e3f8909142c8b2f4b674c2660774c39b28f821");
    }
    // destination Segment
    Segment.logEvent("size_passport_size_guide_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomMadeDesignSharedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * custom_made_design_shared: This event represents when the user clicks in "Send" to share a new custom made design
 * 
 * When to trigger this event:
 * 1. When the user clicks in "Send" in the "Save your design" page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/0dqD99m2Wb2StM-xUOPK0/trigger/EhL9Ld9g1JVopzuT0Por4
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/0dqD99m2Wb2StM-xUOPK0}
 */
export function customMadeDesignShared(properties: CustomMadeDesignSharedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "0dqD99m2Wb2StM-xUOPK0", "f9aa1c705c5c2e3bbbdb4e0f142d387eee5bb239bba9c721742e8c76a4114bb4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("custom_made_design_shared", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("0dqD99m2Wb2StM-xUOPK0", "custom_made_design_shared", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("custom_made_design_shared", eventProperties, "0dqD99m2Wb2StM-xUOPK0", "f9aa1c705c5c2e3bbbdb4e0f142d387eee5bb239bba9c721742e8c76a4114bb4");
    }
    // destination Segment
    Segment.logEvent("custom_made_design_shared", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookStoreAppointmentClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: EventLocationValueType;
}
/**
 * book_store_appointment_clicked: This event represents when the user clicks in "Book appointment" to finish the custom made design in store
 * 
 * When to trigger this event:
 * 1. When the user clicks in "Book appointment" to finish the custom made design in store
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/XpZ6ARx_tSEDsYxHDRdPb/trigger/ipePJ-6xM7ZwC0KS-jAPq
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: Currency code, ISO standard in lowercase letters
 * @param properties.country: Local country of website, ISO standard, lowercase
 * @param properties.language: language used on page, ISO standard, lowercase
 * @param properties.url: URL without locale
 * @param properties.locationId: Url with locale
 * @param properties.userId: Unique customer ID (account number)
 * @param properties.loggedIn: 'true' or 'false'
 * @param properties.pageType: describes the page_type 
 * @param properties.gaClientId: gets the client id from the local storage
 * @param properties.gaSessionId: Gets the Google analytics session id from the local storage
 * @param properties.gaSessionNumber: Gets the session number from the local storage
 * @param properties.fbFbp: fbp cookie value
 * @param properties.fbFbc: fbc
 cookie value
 * @param properties.gaAwClid: Google Adwords click id
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: Overall event category
 * @param properties.eventLocation: Describes where event is located on the website. Never applicable to 'ecommerce' events, and 

- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/uM2Y3M8zQJV5zqtT9_7el/events/XpZ6ARx_tSEDsYxHDRdPb}
 */
export function bookStoreAppointmentClicked(properties: BookStoreAppointmentClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
  eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
  eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
  eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
  eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
  eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
  properties.gaClientId !== undefined && properties.gaClientId !== null ?
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
    eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
  properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
    eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
  properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
    eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
  properties.fbFbp !== undefined && properties.fbFbp !== null ?
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
    eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
  properties.fbFbc !== undefined && properties.fbFbc !== null ?
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
    eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
  properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
    eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "XpZ6ARx_tSEDsYxHDRdPb", "91d576978fa972ab328e13d273940fcf66f3c1dac433f0da87a33f90170232e5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("book_store_appointment_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("XpZ6ARx_tSEDsYxHDRdPb", "book_store_appointment_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("book_store_appointment_clicked", eventProperties, "XpZ6ARx_tSEDsYxHDRdPb", "91d576978fa972ab328e13d273940fcf66f3c1dac433f0da87a33f90170232e5");
    }
    // destination Segment
    Segment.logEvent("book_store_appointment_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  avoInspectorApiKey,
  Language,
  LoggedIn,
  EventCategory,
  Country,
  Affiliation,
  Brand,
  PageType,
  Currency,
  EventLocation,
  productViewed,
  productViewedCm,
  productAdded,
  productAddedCm,
  pageLoaded,
  pageLoadedVirtualPageView,
  pageLoadedCm,
  fabricGroupSelect,
  fabricOptionSelect,
  fabricOptionConfirm,
  styleOptionSelect,
  styleOptionSelectCm,
  styleOptionConfirm,
  basicSectionSelect,
  basicOptionSelect,
  basicOptionConfirm,
  showAdvancedOptions,
  showAdvancedOptionsSp,
  advancedSectionSelect,
  advancedOptionSelect,
  advancedOptionConfirm,
  summarySeeAllDetails,
  summaryFinishInStore,
  summarySaveAndShare,
  summaryEdit,
  fabricFilter,
  fabricInformation,
  custommadeDone,
  styleOptionChange,
  styleOptionChangeConfirm,
  styleOptionChangeCancel,
  monogramChange,
  monogramDelete,
  monogramDeleteConfirm,
  monogramDeleteCancel,
  custommadeAddAdditionalProduct,
  summaryFabricChange,
  summaryFabricChangeCancel,
  summaryFabricChangeConfirm,
  overlayIntroShowed,
  overlayFabricShowed,
  overlayStyleShowed,
  overlayPersonaliseShowed,
  overlayFitShowed,
  customMadeDesigningStarted,
  customMadeOverlayExited,
  searchClicked,
  searchClickedCustomMade,
  customMadeCategoryChanged,
  editSizePassportClicked,
  sizePassportLoginClicked,
  sizePassportSizeGuideClicked,
  customMadeDesignShared,
  bookStoreAppointmentClicked,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["productViewed","productViewedCm","productAdded","productAddedCm","pageLoaded","pageLoadedVirtualPageView","pageLoadedCm","fabricGroupSelect","fabricOptionSelect","fabricOptionConfirm","styleOptionSelect","styleOptionSelectCm","styleOptionConfirm","basicSectionSelect","basicOptionSelect","basicOptionConfirm","showAdvancedOptions","showAdvancedOptionsSp","advancedSectionSelect","advancedOptionSelect","advancedOptionConfirm","summarySeeAllDetails","summaryFinishInStore","summarySaveAndShare","summaryEdit","fabricFilter","fabricInformation","custommadeDone","styleOptionChange","styleOptionChangeConfirm","styleOptionChangeCancel","monogramChange","monogramDelete","monogramDeleteConfirm","monogramDeleteCancel","custommadeAddAdditionalProduct","summaryFabricChange","summaryFabricChangeCancel","summaryFabricChangeConfirm","overlayIntroShowed","overlayFabricShowed","overlayStyleShowed","overlayPersonaliseShowed","overlayFitShowed","customMadeDesigningStarted","customMadeOverlayExited","searchClicked","searchClickedCustomMade","customMadeCategoryChanged","editSizePassportClicked","sizePassportLoginClicked","sizePassportSizeGuideClicked","customMadeDesignShared","bookStoreAppointmentClicked"]
